module.exports = __webpack_public_path__ + "img/joinus-10.95b1553f.png";